<template>
    <div class="field flex-center">
      <div>{{ label }}</div>
      <div class="slot">
        <slot></slot>
      </div>
    </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: () => ""
    }
  },
  data() {
    return {

    };
  },
  methods: {

  },
};
</script>

<style scoped lang="scss">
.field{
  font-size: 14px;
  border-bottom: 1px solid #F3F3F3;
  padding: 10px 0px;
  height: 50px;
  box-sizing: border-box;
}
</style>
